module.exports = ".row{\r\n    padding:37px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/control-data/control-data.component.css
// module id = ./src/app/hrms/payroll/organisation-profile/control-data/control-data.component.css
// module chunks = main